import { Suspense } from 'react';
import { trackEvent } from '@kcd/event-tracker';

import { Chip } from '~/components/Chip';
import { SEARCH_ROUTER } from '~/constants/router';
import { useCurrentUser } from '~/domains/auth/queries';
import { useRecommendSearchKeywords } from '~/domains/keyword/queries';
import { useBusinessIdStore } from '~/store/global/useBusinessIdStore';
import { openPageModal } from '~/utils/mobileApp';

const RecommendKeywordList = () => {
  const businessId = useBusinessIdStore();
  const { user } = useCurrentUser();

  const [value] = useRecommendSearchKeywords();

  const onClickRecommendkeyword = (keyword: string) => {
    trackEvent('clicked tab in 마켓/검색', {
      userId: user?.id,
      keyword,
      businessId,
    });

    openPageModal(SEARCH_ROUTER.searchText(keyword));
  };

  return (
    <div className="overflow-x-auto whitespace-nowrap px-20 pb-8 pt-4 [&::-webkit-scrollbar]:hidden">
      {value?.recommendKeywords.map((keyword) => (
        <Chip
          className="!mr-8 !inline-block"
          key={keyword}
          onClick={() => {
            onClickRecommendkeyword(keyword);
          }}
        >
          {keyword}
        </Chip>
      ))}
    </div>
  );
};

export default function RecommendKeywords() {
  return (
    <Suspense fallback={<div className="h-[44px] w-full" />}>
      <RecommendKeywordList />
    </Suspense>
  );
}
